<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, computed } from "vue";

const { shouldHandle, handler, manual } = defineProps([
  "shouldHandle",
  "handler",
  "manual",
]);
const loadingMore = ref(false);
const fetchMoreError = ref<Error>();
const rootElement = ref<HTMLElement>();
const triggerHeight = 600;

const showMore = async () => {
  if (loadingMore.value) {
    return;
  }
  loadingMore.value = true;
  try {
    await handler();
    fetchMoreError.value = undefined;
  } catch (e) {
    fetchMoreError.value = e as Error;
  }
  loadingMore.value = false;
};
const onScroll = () => {
  if (
    loadingMore.value ||
    !shouldHandle ||
    fetchMoreError.value ||
    !rootElement.value
  ) {
    return;
  }
  let loadMoreNow =
    document.documentElement.scrollTop + window.innerHeight >=
    rootElement.value.offsetTop +
      rootElement.value.offsetHeight -
      triggerHeight;
  if (loadMoreNow) {
    showMore();
  }
};
onMounted(() => {
  if (!manual) {
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);
  }
});
onBeforeUnmount(() => {
  if (!manual) {
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("resize", onScroll);
  }
});
const buttonText = computed(() => {
  if (loadingMore.value) {
    return "Carregando...";
  }
  if (fetchMoreError.value) {
    return "Falha ao carregar mais resultados (tente novamente)";
  }
  return "Mais resultados";
});
</script>

<template>
  <div ref="rootElement" class="infinite-scroll">
    <slot />
    <div class="d-grid">
      <button
        v-if="shouldHandle"
        class="btn btn-secondary"
        :disabled="loadingMore"
        @click="showMore"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>
